import { render, staticRenderFns } from "./main_nav.vue?vue&type=template&id=a2de8124&scoped=true&"
import script from "./main_nav.vue?vue&type=script&lang=ts&"
export * from "./main_nav.vue?vue&type=script&lang=ts&"
import style0 from "./main_nav.vue?vue&type=style&index=0&id=a2de8124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2de8124",
  null
  
)

export default component.exports